import { endOfDay, isAfter, isBefore, isSameDay, startOfDay } from 'date-fns';
import type { Campaign } from 'c-sdk';
import { isoDateNoTimeDiff } from 'c-lib';

export const isCampaignArchived = (campaign: Campaign) => campaign?.progress?.archived === true;

export const isCampaignUpcoming = (campaign: Campaign) =>
    isAfter(startOfDay(isoDateNoTimeDiff(campaign?.date_start)), startOfDay(new Date()));

export const isCampaignLive = (campaign: Campaign) =>
    (isBefore(isoDateNoTimeDiff(campaign?.date_start), startOfDay(new Date())) ||
        isSameDay(isoDateNoTimeDiff(campaign?.date_start), startOfDay(new Date()))) &&
    (isAfter(isoDateNoTimeDiff(campaign?.date_end), endOfDay(new Date())) ||
        isSameDay(isoDateNoTimeDiff(campaign?.date_end), endOfDay(new Date())));

export const isCampaignPast = (campaign: Campaign) =>
    !isCampaignLive(campaign) &&
    isBefore(isoDateNoTimeDiff(campaign?.date_end), endOfDay(new Date()));
